import React from "react";
import { createRoot } from "react-dom/client";
import App from "../components/auth/sign-in/App";
import ToastProvider from "../components/shared/ToastProvider";

document.addEventListener("DOMContentLoaded", () => {
  const rootElement = document.getElementById("auth-sign-in");
  if (rootElement) {
    const root = createRoot(rootElement);
    root.render(
      <>
        <ToastProvider />
        <App />
      </>
    );
  }
});
